module.exports = "<md-card layout=column flex layout-padding> <h3 class=md-title translate>ANNOUNCEMENTS</h3> <md-content> <md-list> <md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"newsItem in $ctrl.latestNews\"> <div class=md-list-item-text> <h4 class=md-subhead>{{ newsItem.title }}</h4> <p>{{ newsItem.date | momentFormatter }}</p> <p>{{ newsItem.content }}</p> </div> </md-list-item> <md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"newsItem in $ctrl.latestNews\"> <div class=md-list-item-text> <cms content-name=\"'announcements'\"></cms> </div> </md-list-item> </md-list> </md-content> </md-card>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/news/news.html
 ** module id = 345
 ** module chunks = 0
 **/